import React from 'react'
// import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { injectIntl, intlShape } from 'react-intl'

class WineAroundDownload extends React.Component {
  render() {
    // const { formatMessage } = this.props.intl;

    return (
      <div className="space--both-2">
        {/* <h2 className="beta">
          <FormattedMessage id="app.reservation.step.3.app.title" />
        </h2>
        <div className="space--both-2">
          <FormattedMessage id="app.reservation.step.3.app.description" />
          <div className="space--both-2 visible--on-desk">
            <img src="/images/qrcode.png" style={{ display: 'block', margin: 'auto' }}/>
            <a
              href={formatMessage({ id: 'app.root.site_url' })}
              alt="WineAround App"
              target="_blank"
              style={{ textAlign: 'center', display: 'block', margin: 'auto' }}
              className="button button--primary"
            >
              <FormattedMessage id="app.reservation.step.3.app.button" />
            </a>
          </div>
          <div className="space--both-2 hidden--on-desk">
            <div className="grid">
              <div className="grid__item width-6-12">
                <a
                  href="//itunes.apple.com/it/app/wine-around/id1006599556"
                  id="appstore-link"
                  target="_blank"
                >
                  <img
                    alt="Download on the App Store"
                    src="/images/Download_on_the_App_Store_Badge_IT_135x40.png"
                  />
                </a>
              </div>
              <div className="grid__item width-6-12">
                <a
                  href="//play.google.com/apps/store/details?id=it.winearound.app"
                  id="play-link"
                  target="_blank"
                >
                  <img
                    alt="Get it on Google Play"
                    src="/images/google-play-badge-it.png"
                  />
                </a>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    )
  }
}

WineAroundDownload.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(WineAroundDownload)
